import Vue from 'vue';
import reportContentForm from '../reportContent/reportContentForm';

const baseElement = document.querySelector('[data-vue-report-content-form]');

if (baseElement) {
    new Vue({
        el: baseElement,
        render(createElement) {
            return createElement(reportContentForm, {
                props: {
                    fieldRecaptcha: JSON.parse(baseElement.querySelector('[data-field-recaptcha]').dataset.fieldRecaptcha),
                    sitekey: baseElement.querySelector('[data-sitekey]').dataset.sitekey,
                },
            });
        },
    });
}
